module.exports = __webpack_public_path__ + "media/images/icons/flags/VN-0e0d9e5e954c00b0d2cc94428142586d.svg";